<template>
<div id="app">
    <v-app id="inspire" light>
        aaaaaaaaaaaaaaaaaaaaaaaaaa
        <muhasebekoducomp  etiket="kodd" maxlength="25" v-model="AccountingCode"></muhasebekoducomp>
        <caricomp v-bind:statecariyedek="caricompitems" v-bind:zorunlumu="true"
                          v-model="Current" ></caricomp>
    </v-app>
</div>
</template>
<script>
 import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
 import caricomp from '@/components/app/customcomp/caricomp.vue'
 export default {
    data() {
        return {
            AccountingCode:null,
            caricompitems: [],
            Current:null
        }
    },
    components: {
       
        muhasebekoducomp,
        caricomp
        
    },
 }

</script>